import { FaChartLine, FaClipboardList, FaCubes } from "react-icons/fa";
import "./_AdminNavBar.scss";
import "./_AdminNavBarMobile.scss";
import { setRedirect } from "../utils/_redirect";
import { FaUsers } from "react-icons/fa6";

function _AdminNavBar({ navStructure, activeNav, setActiveNav }) {
  // Define your icon components as JSX, not just references
  const someIcons = [
    <FaChartLine />,
    <FaUsers />,
    <FaCubes />,
    <FaClipboardList />,
  ];

  return (
    <nav className="admin-nav-container">
      {navStructure.map((item, index) => (
        <div
          className={`nav-item-wrapper ${
            activeNav === index ? "activeNav" : ""
          }`}
          key={index}
          onClick={() => {
            setActiveNav(index);
            setRedirect(index, 0);
          }}
        >
          <span className="nav-icon">{someIcons[index]}</span>
          <span className="nav-label">{item}</span>
        </div>
      ))}
    </nav>
  );
}

export default _AdminNavBar;
